import { ELanguage } from '#core/const/locales';
import { useSupplierFetch } from '#hook/use-supplier-fetch';

/**
    CountryCode может быть
    cn - китай
    hk - гонконг
    mo - макао
    это все Китай

    ru - Российская Федерация
    by - Республика Белоруссия
    kz - Республика Казахстан
    kg - Киргизская Республика
    tj - Республика Таджикистан
    uz - Республика Узбекистан
    Страны СНГ
 * */
export const CHINESE_CODE = ['cn', 'hk', 'mo'];
export const CIS_CODE = ['ru', 'by', 'kz', 'kg', 'tj', 'uz'];

export const useCountryCode = () => {
    const { data: { countryCode } = {} } = useSupplierFetch();

    const isChinese = countryCode && CHINESE_CODE.includes(countryCode);
    const isRussian = countryCode === ELanguage.RU;
    const isCIS = countryCode && CIS_CODE.includes(countryCode);

    return { isChinese, isRussian, isCIS, countryCode };
};
